import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEdit = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 17C8.13 17 8.26 16.95 8.35 16.85L18.56 6.61998C19.14 6.03998 19.14 5.07998 18.56 4.49998L17.5 3.43998C16.92 2.85998 15.96 2.84998 15.38 3.43998L5.15 13.65C5.06 13.74 5 13.87 5 14V16.5C5 16.78 5.22 17 5.5 17H8ZM16.09 4.14998C16.29 3.94998 16.6 3.94998 16.8 4.14998L17.86 5.20998C18.06 5.40998 18.06 5.71998 17.86 5.91998L16.09 7.68998L14.32 5.91998L16.09 4.14998ZM6 14.21L13.61 6.61998L15.38 8.38998L7.79 16H6V14.21Z'
    />
    <path d='M3.5 20C3.22 20 3 20.22 3 20.5C3 20.78 3.22 21 3.5 21H20.5C20.78 21 21 20.78 21 20.5C21 20.22 20.78 20 20.5 20H3.5Z' />
  </svg>
);
export default SvgEdit;
